<ng-container *ngIf="!actions.length">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="popUpTypes.Info">
      <div class="popup-dialog-no-actions popup-dialog-info">
        <div class="alert-popup-dialog-icon">
          <svg
            width="35"
            height="35"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
              fill="#0280A3"
            />
          </svg>
        </div>
        <div class="popup-dialog-message">{{ message }}</div>
        <div class="popup-dialog-close-button" (click)="closePopUp(false)">
          <svg
            width="49"
            height="49"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.4099 20.0002L25.7099 15.7102C25.8982 15.5219 26.004 15.2665 26.004 15.0002C26.004 14.7339 25.8982 14.4785 25.7099 14.2902C25.5216 14.1019 25.2662 13.9961 24.9999 13.9961C24.7336 13.9961 24.4782 14.1019 24.2899 14.2902L19.9999 18.5902L15.7099 14.2902C15.5216 14.1019 15.2662 13.9961 14.9999 13.9961C14.7336 13.9961 14.4782 14.1019 14.2899 14.2902C14.1016 14.4785 13.9958 14.7339 13.9958 15.0002C13.9958 15.2665 14.1016 15.5219 14.2899 15.7102L18.5899 20.0002L14.2899 24.2902C14.1962 24.3831 14.1218 24.4937 14.071 24.6156C14.0203 24.7375 13.9941 24.8682 13.9941 25.0002C13.9941 25.1322 14.0203 25.2629 14.071 25.3848C14.1218 25.5066 14.1962 25.6172 14.2899 25.7102C14.3829 25.8039 14.4935 25.8783 14.6154 25.9291C14.7372 25.9798 14.8679 26.006 14.9999 26.006C15.132 26.006 15.2627 25.9798 15.3845 25.9291C15.5064 25.8783 15.617 25.8039 15.7099 25.7102L19.9999 21.4102L24.2899 25.7102C24.3829 25.8039 24.4935 25.8783 24.6154 25.9291C24.7372 25.9798 24.8679 26.006 24.9999 26.006C25.132 26.006 25.2627 25.9798 25.3845 25.9291C25.5064 25.8783 25.617 25.8039 25.7099 25.7102C25.8037 25.6172 25.8781 25.5066 25.9288 25.3848C25.9796 25.2629 26.0057 25.1322 26.0057 25.0002C26.0057 24.8682 25.9796 24.7375 25.9288 24.6156C25.8781 24.4937 25.8037 24.3831 25.7099 24.2902L21.4099 20.0002Z"
              fill="#333333"
            />
          </svg>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="popUpTypes.Alert">
      <div class="popup-dialog-no-actions popup-dialog-alert">
        <div class="alert-popup-dialog-icon">
          <svg
            width="35"
            height="35"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
              fill="#D07F33"
            />
          </svg>
        </div>
        <div class="popup-dialog-message">{{ message }}</div>

        <div class="popup-dialog-close-button" (click)="closePopUp(false)">
          <svg
            width="49"
            height="49"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.4099 20.0002L25.7099 15.7102C25.8982 15.5219 26.004 15.2665 26.004 15.0002C26.004 14.7339 25.8982 14.4785 25.7099 14.2902C25.5216 14.1019 25.2662 13.9961 24.9999 13.9961C24.7336 13.9961 24.4782 14.1019 24.2899 14.2902L19.9999 18.5902L15.7099 14.2902C15.5216 14.1019 15.2662 13.9961 14.9999 13.9961C14.7336 13.9961 14.4782 14.1019 14.2899 14.2902C14.1016 14.4785 13.9958 14.7339 13.9958 15.0002C13.9958 15.2665 14.1016 15.5219 14.2899 15.7102L18.5899 20.0002L14.2899 24.2902C14.1962 24.3831 14.1218 24.4937 14.071 24.6156C14.0203 24.7375 13.9941 24.8682 13.9941 25.0002C13.9941 25.1322 14.0203 25.2629 14.071 25.3848C14.1218 25.5066 14.1962 25.6172 14.2899 25.7102C14.3829 25.8039 14.4935 25.8783 14.6154 25.9291C14.7372 25.9798 14.8679 26.006 14.9999 26.006C15.132 26.006 15.2627 25.9798 15.3845 25.9291C15.5064 25.8783 15.617 25.8039 15.7099 25.7102L19.9999 21.4102L24.2899 25.7102C24.3829 25.8039 24.4935 25.8783 24.6154 25.9291C24.7372 25.9798 24.8679 26.006 24.9999 26.006C25.132 26.006 25.2627 25.9798 25.3845 25.9291C25.5064 25.8783 25.617 25.8039 25.7099 25.7102C25.8037 25.6172 25.8781 25.5066 25.9288 25.3848C25.9796 25.2629 26.0057 25.1322 26.0057 25.0002C26.0057 24.8682 25.9796 24.7375 25.9288 24.6156C25.8781 24.4937 25.8037 24.3831 25.7099 24.2902L21.4099 20.0002Z"
              fill="#333333"
            />
          </svg>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="popUpTypes.Success">
      <div class="popup-dialog-no-actions popup-dialog-success">
        <div class="alert-popup-dialog-icon">
          <svg
            width="35"
            height="35"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" fill="#02A355" />
            <path
              d="M10.2141 14.7941C10.3071 14.8878 10.4177 14.9622 10.5395 15.013C10.6614 15.0638 10.7921 15.0899 10.9241 15.0899C11.0561 15.0899 11.1868 15.0638 11.3087 15.013C11.4305 14.9622 11.5411 14.8878 11.6341 14.7941L15.7141 10.7141C15.9024 10.5258 16.0082 10.2704 16.0082 10.0041C16.0082 9.73779 15.9024 9.48239 15.7141 9.29409C15.5258 9.10579 15.2704 9 15.0041 9C14.7378 9 14.4824 9.10579 14.2941 9.29409L10.9241 12.6741L9.71409 11.4541C9.52579 11.2658 9.27039 11.16 9.00409 11.16C8.73779 11.16 8.4824 11.2658 8.29409 11.4541C8.10579 11.6424 8 11.8978 8 12.1641C8 12.4304 8.10579 12.6858 8.29409 12.8741L10.2141 14.7941Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="popup-dialog-message">{{ message }}</div>
        <div class="popup-dialog-close-button" (click)="closePopUp(false)">
          <svg
            width="49"
            height="49"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.4099 20.0002L25.7099 15.7102C25.8982 15.5219 26.004 15.2665 26.004 15.0002C26.004 14.7339 25.8982 14.4785 25.7099 14.2902C25.5216 14.1019 25.2662 13.9961 24.9999 13.9961C24.7336 13.9961 24.4782 14.1019 24.2899 14.2902L19.9999 18.5902L15.7099 14.2902C15.5216 14.1019 15.2662 13.9961 14.9999 13.9961C14.7336 13.9961 14.4782 14.1019 14.2899 14.2902C14.1016 14.4785 13.9958 14.7339 13.9958 15.0002C13.9958 15.2665 14.1016 15.5219 14.2899 15.7102L18.5899 20.0002L14.2899 24.2902C14.1962 24.3831 14.1218 24.4937 14.071 24.6156C14.0203 24.7375 13.9941 24.8682 13.9941 25.0002C13.9941 25.1322 14.0203 25.2629 14.071 25.3848C14.1218 25.5066 14.1962 25.6172 14.2899 25.7102C14.3829 25.8039 14.4935 25.8783 14.6154 25.9291C14.7372 25.9798 14.8679 26.006 14.9999 26.006C15.132 26.006 15.2627 25.9798 15.3845 25.9291C15.5064 25.8783 15.617 25.8039 15.7099 25.7102L19.9999 21.4102L24.2899 25.7102C24.3829 25.8039 24.4935 25.8783 24.6154 25.9291C24.7372 25.9798 24.8679 26.006 24.9999 26.006C25.132 26.006 25.2627 25.9798 25.3845 25.9291C25.5064 25.8783 25.617 25.8039 25.7099 25.7102C25.8037 25.6172 25.8781 25.5066 25.9288 25.3848C25.9796 25.2629 26.0057 25.1322 26.0057 25.0002C26.0057 24.8682 25.9796 24.7375 25.9288 24.6156C25.8781 24.4937 25.8037 24.3831 25.7099 24.2902L21.4099 20.0002Z"
              fill="#333333"
            />
          </svg>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-container *ngIf="actions.length">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="popUpTypes.Info">
      <div class="popup-dialog popup-dialog-info">
        <div class="alert-popup-dialog-icon">
          <svg
            width="35"
            height="35"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
              fill="#0280A3"
            />
          </svg>
        </div>
        <div class="popup-dialog-message">{{ message }}</div>
        <ng-container *ngFor="let action of actions">
          <button
            class="popup-andromeda-basic-button"
            (click)="closePopUp(action.value)"
          >
            {{ action.text }}
          </button>
        </ng-container>
        <div class="popup-dialog-close-button" (click)="closePopUp(false)">
          <svg
            width="49"
            height="49"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.4099 20.0002L25.7099 15.7102C25.8982 15.5219 26.004 15.2665 26.004 15.0002C26.004 14.7339 25.8982 14.4785 25.7099 14.2902C25.5216 14.1019 25.2662 13.9961 24.9999 13.9961C24.7336 13.9961 24.4782 14.1019 24.2899 14.2902L19.9999 18.5902L15.7099 14.2902C15.5216 14.1019 15.2662 13.9961 14.9999 13.9961C14.7336 13.9961 14.4782 14.1019 14.2899 14.2902C14.1016 14.4785 13.9958 14.7339 13.9958 15.0002C13.9958 15.2665 14.1016 15.5219 14.2899 15.7102L18.5899 20.0002L14.2899 24.2902C14.1962 24.3831 14.1218 24.4937 14.071 24.6156C14.0203 24.7375 13.9941 24.8682 13.9941 25.0002C13.9941 25.1322 14.0203 25.2629 14.071 25.3848C14.1218 25.5066 14.1962 25.6172 14.2899 25.7102C14.3829 25.8039 14.4935 25.8783 14.6154 25.9291C14.7372 25.9798 14.8679 26.006 14.9999 26.006C15.132 26.006 15.2627 25.9798 15.3845 25.9291C15.5064 25.8783 15.617 25.8039 15.7099 25.7102L19.9999 21.4102L24.2899 25.7102C24.3829 25.8039 24.4935 25.8783 24.6154 25.9291C24.7372 25.9798 24.8679 26.006 24.9999 26.006C25.132 26.006 25.2627 25.9798 25.3845 25.9291C25.5064 25.8783 25.617 25.8039 25.7099 25.7102C25.8037 25.6172 25.8781 25.5066 25.9288 25.3848C25.9796 25.2629 26.0057 25.1322 26.0057 25.0002C26.0057 24.8682 25.9796 24.7375 25.9288 24.6156C25.8781 24.4937 25.8037 24.3831 25.7099 24.2902L21.4099 20.0002Z"
              fill="#333333"
            />
          </svg>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="popUpTypes.Alert">
      <div class="popup-dialog popup-dialog-alert">
        <div class="alert-popup-dialog-icon">
          <svg
            width="35"
            height="35"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
              fill="#D07F33"
            />
          </svg>
        </div>
        <div class="popup-dialog-message">{{ message }}</div>
        <ng-container *ngFor="let action of actions">
          <button
            class="popup-andromeda-basic-button"
            (click)="closePopUp(action.value)"
          >
            {{ action.text }}
          </button>
        </ng-container>
        <div class="popup-dialog-close-button" (click)="closePopUp(false)">
          <svg
            width="49"
            height="49"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.4099 20.0002L25.7099 15.7102C25.8982 15.5219 26.004 15.2665 26.004 15.0002C26.004 14.7339 25.8982 14.4785 25.7099 14.2902C25.5216 14.1019 25.2662 13.9961 24.9999 13.9961C24.7336 13.9961 24.4782 14.1019 24.2899 14.2902L19.9999 18.5902L15.7099 14.2902C15.5216 14.1019 15.2662 13.9961 14.9999 13.9961C14.7336 13.9961 14.4782 14.1019 14.2899 14.2902C14.1016 14.4785 13.9958 14.7339 13.9958 15.0002C13.9958 15.2665 14.1016 15.5219 14.2899 15.7102L18.5899 20.0002L14.2899 24.2902C14.1962 24.3831 14.1218 24.4937 14.071 24.6156C14.0203 24.7375 13.9941 24.8682 13.9941 25.0002C13.9941 25.1322 14.0203 25.2629 14.071 25.3848C14.1218 25.5066 14.1962 25.6172 14.2899 25.7102C14.3829 25.8039 14.4935 25.8783 14.6154 25.9291C14.7372 25.9798 14.8679 26.006 14.9999 26.006C15.132 26.006 15.2627 25.9798 15.3845 25.9291C15.5064 25.8783 15.617 25.8039 15.7099 25.7102L19.9999 21.4102L24.2899 25.7102C24.3829 25.8039 24.4935 25.8783 24.6154 25.9291C24.7372 25.9798 24.8679 26.006 24.9999 26.006C25.132 26.006 25.2627 25.9798 25.3845 25.9291C25.5064 25.8783 25.617 25.8039 25.7099 25.7102C25.8037 25.6172 25.8781 25.5066 25.9288 25.3848C25.9796 25.2629 26.0057 25.1322 26.0057 25.0002C26.0057 24.8682 25.9796 24.7375 25.9288 24.6156C25.8781 24.4937 25.8037 24.3831 25.7099 24.2902L21.4099 20.0002Z"
              fill="#333333"
            />
          </svg>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="popUpTypes.Success">
      <div class="popup-dialog popup-dialog-success">
        <div class="alert-popup-dialog-icon">
          <svg
            width="35"
            height="35"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" fill="#02A355" />
            <path
              d="M10.2141 14.7941C10.3071 14.8878 10.4177 14.9622 10.5395 15.013C10.6614 15.0638 10.7921 15.0899 10.9241 15.0899C11.0561 15.0899 11.1868 15.0638 11.3087 15.013C11.4305 14.9622 11.5411 14.8878 11.6341 14.7941L15.7141 10.7141C15.9024 10.5258 16.0082 10.2704 16.0082 10.0041C16.0082 9.73779 15.9024 9.48239 15.7141 9.29409C15.5258 9.10579 15.2704 9 15.0041 9C14.7378 9 14.4824 9.10579 14.2941 9.29409L10.9241 12.6741L9.71409 11.4541C9.52579 11.2658 9.27039 11.16 9.00409 11.16C8.73779 11.16 8.4824 11.2658 8.29409 11.4541C8.10579 11.6424 8 11.8978 8 12.1641C8 12.4304 8.10579 12.6858 8.29409 12.8741L10.2141 14.7941Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="popup-dialog-message">{{ message }}</div>
        <ng-container *ngFor="let action of actions">
          <button
            class="popup-andromeda-basic-button"
            (click)="closePopUp(action.value)"
          >
            {{ action.text }}
          </button>
        </ng-container>
        <div class="popup-dialog-close-button" (click)="closePopUp(false)">
          <svg
            width="49"
            height="49"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.4099 20.0002L25.7099 15.7102C25.8982 15.5219 26.004 15.2665 26.004 15.0002C26.004 14.7339 25.8982 14.4785 25.7099 14.2902C25.5216 14.1019 25.2662 13.9961 24.9999 13.9961C24.7336 13.9961 24.4782 14.1019 24.2899 14.2902L19.9999 18.5902L15.7099 14.2902C15.5216 14.1019 15.2662 13.9961 14.9999 13.9961C14.7336 13.9961 14.4782 14.1019 14.2899 14.2902C14.1016 14.4785 13.9958 14.7339 13.9958 15.0002C13.9958 15.2665 14.1016 15.5219 14.2899 15.7102L18.5899 20.0002L14.2899 24.2902C14.1962 24.3831 14.1218 24.4937 14.071 24.6156C14.0203 24.7375 13.9941 24.8682 13.9941 25.0002C13.9941 25.1322 14.0203 25.2629 14.071 25.3848C14.1218 25.5066 14.1962 25.6172 14.2899 25.7102C14.3829 25.8039 14.4935 25.8783 14.6154 25.9291C14.7372 25.9798 14.8679 26.006 14.9999 26.006C15.132 26.006 15.2627 25.9798 15.3845 25.9291C15.5064 25.8783 15.617 25.8039 15.7099 25.7102L19.9999 21.4102L24.2899 25.7102C24.3829 25.8039 24.4935 25.8783 24.6154 25.9291C24.7372 25.9798 24.8679 26.006 24.9999 26.006C25.132 26.006 25.2627 25.9798 25.3845 25.9291C25.5064 25.8783 25.617 25.8039 25.7099 25.7102C25.8037 25.6172 25.8781 25.5066 25.9288 25.3848C25.9796 25.2629 26.0057 25.1322 26.0057 25.0002C26.0057 24.8682 25.9796 24.7375 25.9288 24.6156C25.8781 24.4937 25.8037 24.3831 25.7099 24.2902L21.4099 20.0002Z"
              fill="#333333"
            />
          </svg>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
